module.exports = __webpack_public_path__ + "img/wx-pay.f081619e.png";